import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import "../Styles/Footer.css";
import logo from "../Images/logo.jpg";
import { CONTACT, SOCIALS } from "../Scripts/siteData";

function Footer() {
  return (
    <footer className="footer-section">
      <div className="hr-container">
        <div className="footer-grid">
          <div className="footer-col">
            <div className="footer-brand">
              <img src={logo} alt="Harmony Rise Homecare" className="footer-logo" />
              <span className="footer-brand-text">
                Harmony Rise
                <small>Home Care</small>
              </span>
            </div>
            <p className="footer-about">
              Compassionate, nonmedical in-home care that helps every client
              live with dignity, comfort and independence.
            </p>
            <div className="footer-socials">
              {SOCIALS.map((s) => (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                >
                  <FontAwesomeIcon icon={s.icon} />
                </a>
              ))}
            </div>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/apply">Apply with Us</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <Link to="/book-appointment">Book An Appointment</Link>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Our Care</h4>
            <ul>
              <li>
                <Link to="/services">Personal Care</Link>
              </li>
              <li>
                <Link to="/services">Companion Care</Link>
              </li>
              <li>
                <Link to="/services">Dementia Care</Link>
              </li>
              <li>
                <Link to="/services">Life Care Services</Link>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Get In Touch</h4>
            <ul>
              <li>
                <a href={CONTACT.phoneHref} className="footer-contact-item">
                  <FontAwesomeIcon icon={faPhone} /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={CONTACT.emailHref} className="footer-contact-item">
                  <FontAwesomeIcon icon={faEnvelope} /> {CONTACT.email}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.addressMap}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-contact-item"
                >
                  <FontAwesomeIcon icon={faLocationDot} /> {CONTACT.address}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>
            © {new Date().getFullYear()} Harmony Rise Homecare. All rights
            reserved.
          </span>
          <span>
            <Link to="/legal">Privacy Policy</Link> &nbsp;•&nbsp;{" "}
            <Link to="/legal">Terms of Service</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
